<template>
  <div >

    <Cbarra>
        <template slot="slotTitle">{{Politica.Nombre}}</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <a href="">{{Politica.Nombre}}</a>
        </template>
    </Cbarra>

    <div class="container">
        <div class="bg-principal-02">
            <div class="row justify-content-center">
                <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10">
                    <h6 v-if="Politica.Subtitulo != ''" class="text-center">{{Politica.Subtitulo}}</h6>

                    <div v-if="Politica.Descripcion != ''" class="text-justify" v-html="Politica.Descripcion"></div>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>
<script>
export default {
    data() {
        return {
            Politica:{
                IdPolitica:'',
                Nombre:'',
                Descripcion:'',
                Subtitulo:''
            }
        }
    },methods: {
         get_one(Id)
        {
            this.$http.get('inicio/recoverypolitica',
            {
                params:{IdPolitica: Id}
            })
            .then(res => {
                this.Politica = res.data.data.Politica;
                
            });
        },
    },mounted() {
        window.scrollTo(0, 0);

        this.bus.$off('CambiarPolitica');
        this.bus.$on('CambiarPolitica',(id)=>
        {
           this.get_one(id);
           sessionStorage.IdPolitica = id;
        });

      
        if(this.$route.params.id > 0){

            this.get_one(this.$route.params.id);
            sessionStorage.IdPolitica = this.$route.params.id;

        }else{
            this.get_one(sessionStorage.IdPolitica);
        }

    },
}
</script>